import React from 'react';
interface FiretreeEmblemProps {
  className?: string;
  size?: number;
}
export function FiretreeEmblem({
  className = '',
  size = 28
}: FiretreeEmblemProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true" data-id="element-66">
      {/* Top-right petal */}
      <path d="M 52 48 C 58 30 72 20 85 18 C 78 32 68 42 52 48 Z" fill="currentColor" data-id="element-67" />
      {/* Bottom-right petal */}
      <path d="M 52 52 C 70 58 80 72 82 85 C 68 78 58 68 52 52 Z" fill="currentColor" data-id="element-68" />
      {/* Bottom-left petal */}
      <path d="M 48 52 C 42 70 28 80 15 82 C 22 68 32 58 48 52 Z" fill="currentColor" data-id="element-69" />
      {/* Top-left petal */}
      <path d="M 48 48 C 30 42 20 28 18 15 C 32 22 42 32 48 48 Z" fill="currentColor" data-id="element-70" />
    </svg>;
}